import styled from 'styled-components';
import { TILE_SIZE_LARGE } from '../../../styles/global';

export const iconSize = TILE_SIZE_LARGE - 0.4;

export const CloseIcon = styled.div`
  &::before,
  &::after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    width: ${iconSize}vmin;
    height: 0.4vmin;
    background-color: white;
    transform: translate(-50%, -50%);
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const CollapseIcon = styled.div`
  &::after {
    position: absolute;
    content: '';
    top: 70%;
    left: 30%;
    width: 35%;
    height: 0.4vmin;
    background-color: white;
    transform: translate(-50%, -50%);
  }
`;

export const ExpandIcon = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0.3vmin;
  border: 0.3vmin solid white;
  border-top-width: 0.6vmin;
`;

export const MineSweeperIcon = styled.div`
  width: ${iconSize + 0.7}vmin;
  height: ${iconSize + 0.7}vmin;
  background-image: url('./assets/oldTheme/icon.webp');
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 0.3vmin;
  margin-right: 1vmin;
`;
